
import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,

        	// NOTE :::::::::::::::::::::::::::: that how's the widget looks like
        	/* 
        		<div class="widget-read-more">
        			<div class="">text ...</div>
                    <a href="#" class="read-more"></a>
                    <div class="text-more">more text ...</div>
        		</div>
        	*/


            default_state_open: false,
            text_more: 'Read More +',
            text_less: 'Read Less -'
        };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'read_more';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

        this.$a             =   this.$el.find( 'a.read-more' );
        this.$button_text   =   this.$el.find( '.read-more-trigger' );
        this.$text_more     =   this.$el.find( '.text-more' );

		if ( this.$a.length > 0 && this.$text_more.length > 0 ){
			this.init();
		}

        this.$el.addClass('init');
    }

    init(){
        this.$el.data( 'open', this.options.default_state_open );
       

        if ( this.options.default_state_open ){
            this.$button_text.text( this.options.text_less );
            this.$el.addClass( 'open' );
            this.$text_more.show(0);
        }
        else{
            this.$text_more.slideUp(0);
            this.$button_text.text( this.options.text_more );
        }
        


        //this.$text_more.slideUp(0);
        //this.$button_text.text( this.options.text_more );

    	this.addEvents( true );

        //this.$el.data( 'open', false );
        //if ( this.options.default_state_open ){
            //this.$a.trigger( 'click' );
        //}
	}

    addEvents( b ){
        if ( b ){
            this.$a.on( 'click', (e) => this.toggleReadMore(e) );
        }
        else{
            this.$a.off( 'click', (e) => this.toggleReadMore(e) );
        }
    }


    toggleReadMore(e){
        e.preventDefault();
        let open = this.$el.data( 'open' );

        if ( open ){
            this.$text_more.slideUp();
            if (this.options.text_more && this.options.text_more != 'false') {
                this.$a.show();
                this.$button_text.text( this.options.text_more );
            } else {
                this.$a.hide();                
            }
        }
        else{
            this.$text_more.slideDown();
            if (this.options.text_less && this.options.text_less != 'false') {
                this.$a.show();
                this.$button_text.text( this.options.text_less );
            } else {
                this.$a.hide();                
            }
        }
        gsap.fromTo( this.$text_more, { opacity: open ? 1 : 0 }, { opacity: open ? 0 : 1, duration: open ? 0.4 : 0.6 } );

        this.$el.data( 'open', !open );

        if ( open ){
            this.$el.removeClass( 'open' );
        }
        else{
            this.$el.addClass( 'open' );
        }

        return false;
    }

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        if ( this.$a.length > 0 && this.$text_more.length > 0 ){
            this.addEvents( false );
        }
    }

}